(ns nl.mediquest.ui.interceptor
  (:require
   [re-frame.core]))

(defn ->gtag-event-interceptor
  "Creates a re-frame interceptor for Google Tag (gtag) events.

  Args:
    `event-name`: A string representing the name of the gtag event.
    `event-param-fn`: A function that takes the interceptor context and returns
                      the event parameters.

  Returns:
    A re-frame interceptor that, when triggered, sends an event to Google
    Analytics using gtag. The interceptor extracts the event parameters by
    applying `event-param-fn` to the context. If the event generation fails, an
    error is logged to the console.

  Example:
    ```
    (->gtag-event-interceptor
      \"page_view\"
      (fn [context]
        {:page_path (get-in context [:coeffects :route])}))
    ```"
  [event-name event-param-fn]
  (re-frame.core/->interceptor
   :id :gtag-event
   :after (fn [context]
            (try
              (let [^js gtag-ev (event-param-fn context)]
                (js/gtag "event" event-name gtag-ev))
              (catch js/Error e
                (js/console.error (str "GTAG Event failed: " event-name) e)))
            context)))
